<template>
  <Menu></Menu>
  <div id="box">
    asddadas
  </div>
</template>
<!-- ******************************************************** -->
<script>
  export default {
    name: 'DashboardPage',
    data(){
      return {
        loading: false,
      }
    },
    methods:{
      async login(){
        this.loading = true;
        // this.loginAction();
        this.loading = false;
      },
    }
  }
</script>
<!-- ******************************************************** -->
<style scoped>
</style>
  